var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ods-color-svpanel",style:({
      backgroundColor: _vm.background
    })},[_c('div',{staticClass:"ods-color-svpanel__white"}),_c('div',{staticClass:"ods-color-svpanel__black"}),_c('div',{staticClass:"ods-color-svpanel__cursor",style:({
      top: _vm.cursorTop + 'px',
      left: _vm.cursorLeft + 'px'
    })},[_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }